import { Grid, Typography } from '@mui/material';
import type { Currency, PerUnitProductVariantInput } from '@weft/types';
import { withDefault } from '@weft/utils';
import React from 'react';
import { Price } from '../../../../../../../../components/design/Price';

type LivePreviewPerUnitItemProps = {
  productVariant: PerUnitProductVariantInput;
  currency: Currency;
};

export const LivePreviewPerUnitItem: React.FC<LivePreviewPerUnitItemProps> = ({ productVariant, currency }) => {
  return (
    <Grid
      component="li"
      container
    >
      <Grid
        item
        xs={6}
      >
        <Typography
          color="#111B1E"
          fontWeight={400}
          fontSize="12px"
          lineHeight="16px"
        >
          {withDefault(productVariant.name, '')}
        </Typography>
      </Grid>
      <Grid
        item
        xs={6}
        textAlign="right"
      >
        <Typography
          color="#9DA8AC"
          fontWeight={300}
          fontSize="12px"
          lineHeight="16px"
        >
          Price Per Unit
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        textAlign="right"
      >
        <Price
          color="#111B1E"
          fontWeight={400}
          fontSize="12px"
          lineHeight="16px"
          currency={currency}
          align="right"
        >
          {withDefault(productVariant.pricing.priceConfiguration?.price, 0)}
        </Price>
      </Grid>
    </Grid>
  );
};